export default __webpack_public_path__ + "static/media/image8.3b9e932f.svg";